var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout olap-reports" },
    [
      _c("m-category", {
        ref: "categoryModal",
        attrs: { code: _vm.code },
        on: { created: _vm.onCategoryAdded, updated: _vm.onCategoryUpdated },
      }),
      _c("m-report", {
        ref: "reportModal",
        attrs: { code: _vm.code },
        on: {
          created: _vm.onReportAdded,
          updated: _vm.onReportUpdated,
          removed: _vm.onReportRemoved,
        },
      }),
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("m-description", { ref: "description", attrs: { code: _vm.code } }),
      _c("div", { staticClass: "layout-header" }, [
        _c("h1", { staticClass: "layout-title" }, [_vm._v(_vm._s(_vm.title))]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button", {
                attrs: {
                  size: "small",
                  label: "Новая категория",
                  icon: {
                    icon: "plus",
                    color: "primary",
                  },
                },
                on: { click: _vm.createCategory },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button", {
                attrs: {
                  size: "small",
                  label: "Новый отчет",
                  icon: {
                    icon: "plus",
                    color: "primary",
                  },
                },
                on: { click: _vm.createReport },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "olap-reports__content" },
        [
          _vm.loading
            ? _c("loader", {
                attrs: {
                  active: _vm.loading,
                  height: 450,
                  label: "Данные загружаются",
                },
              })
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "olap-reports__search" },
                  [
                    _c("c-input", {
                      staticClass: "search",
                      attrs: {
                        placeholder: "Поиск",
                        clearable: true,
                        icon: "search",
                      },
                      on: { enter: _vm.applySearch },
                      model: {
                        value: _vm.query,
                        callback: function ($$v) {
                          _vm.query = $$v
                        },
                        expression: "query",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "olap-reports__list" },
                  [
                    _vm.isEmpty
                      ? _c("div", { staticClass: "empty-message" }, [
                          _vm.query
                            ? _c("div", [
                                _vm._v(
                                  "Ничего не найдено. Попробуйте изменить параметры поиска"
                                ),
                              ])
                            : _c("div", [_vm._v("Отчетов пока нет")]),
                        ])
                      : _vm._e(),
                    _c("draggable-list", {
                      on: {
                        moveGroups: _vm.resortCategories,
                        addItemToGroup: _vm.onAddReportToCategory,
                        moveItemsInGroup: _vm.resortCategory,
                        removeItemFromGroup: _vm.onRemoveReportFromCategory,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "group",
                          fn: function (slotProps) {
                            return [
                              _c("report-category", {
                                attrs: {
                                  category: slotProps.group.data,
                                  open: slotProps.group.open,
                                },
                                on: {
                                  toggle: _vm.toggleCategory,
                                  edit: _vm.editCategory,
                                  remove: _vm.removeCategory,
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item",
                          fn: function (slotProps) {
                            return [
                              _c("report-item", {
                                attrs: {
                                  report: slotProps.item,
                                  code: _vm.code,
                                },
                                on: {
                                  config: _vm.toReportConfig,
                                  showDescription: _vm.showReportDescription,
                                  edit: _vm.editReport,
                                  remove: _vm.removeReport,
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.list,
                        callback: function ($$v) {
                          _vm.list = $$v
                        },
                        expression: "list",
                      },
                    }),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }